import {
  EntityLookupSearchCriteria,
  TableFilterLookupObjectBody,
} from '@ui-kit'
import {
  IEntityCategoryPayload,
  IFetchEligibilityRulesParams,
  IUpdateRulePayloadType,
} from '../types'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'
import { parseRuleCompositeKey } from '../utils/functions'
import { ENTITY_NAMES } from '../constants'

export const fetchCriteria = async () => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}v1/eligibility_configuration/criteria`
  )
}

export const fetchRulesOffCriteria = async (
  params: IFetchEligibilityRulesParams
) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}v1/eligibility_configuration/rules?scopeId=${params.id}`
  )
}

export const fetchRule = async (rule_name: string) => {
  const parsed = parseRuleCompositeKey(rule_name)
  const basePath = `${
    API_END_POINT.CORE
  }v1/eligibility_configuration/${parsed?.ruleName?.toLowerCase()}`
  const query = new URLSearchParams({
    configId: parsed?.config_id,
  })

  return await axiosInstance.get(`${basePath}?${query.toString()}`)
}

export const updateCorrespondingRules = async (
  payload: IUpdateRulePayloadType
) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}v1/eligibility_configuration`,
    payload
  )
}

export const fetchEntityCategory = async (payload: IEntityCategoryPayload) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/category`,
    payload
  )
}

export const fetchResidencyEntity = async (payload: IEntityCategoryPayload) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/${payload?.entity_name}`,
    payload
  )
}
export const fetchEligibilityConfigurationListing = async (payload: {
  filters: EntityLookupSearchCriteria[]
  related_entities: TableFilterLookupObjectBody
  select: string[]
  entity_name: string
  page: number
  size: number
}) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/${ENTITY_NAMES.PAP_ELIGIBILITY_CONFIGURATIONS}`,
    payload
  )
}

export const fetchEntityViewData = async (
  entityName: string,
  payload: {
    select: string[]
    page?: number
    size?: number
    filters?: EntityLookupSearchCriteria[]
    related_entities?: TableFilterLookupObjectBody
    layout_id?: number
  }
) => {
  return await axiosInstance.post(
    `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/${entityName}`,
    {
      ...payload,
      entity_name: entityName,
    }
  )
}
